import { Actions, thunk } from 'easy-peasy';

import api from '~/services/api';
import { IAiAssistActions, IThunkOnGetAiPrompt } from '../types';

const onGetAiPrompt: IThunkOnGetAiPrompt = thunk(
  async ({ setAiPrompt }: Actions<IAiAssistActions>, payload) => {
    const { data } = await api.aiAssist.getAiPrompt(payload.clinicId);
    setAiPrompt(data?.value);
  },
);

export default onGetAiPrompt;
